import { Link } from 'react-router-dom'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-800 text-white mt-auto">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-2 text-gray-300">
              <p>3154 Sumac Drive</p>
              <p>Peachtree Corners, GA 30360</p>
              <p className="mt-4">
                <a
                  href="mailto:admin@lockridgeforestswimtennis.com"
                  className="hover:text-blue-400 transition-colors"
                >
                  admin@lockridgeforestswimtennis.com
                </a>
              </p>
              <p>
                <a
                  href="tel:7706097428"
                  className="hover:text-blue-400 transition-colors"
                >
                  (770) 609-7428 (text or leave voicemail)
                </a>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-300">
              <li>
                <Link to="/membership" className="hover:text-blue-400 transition-colors">
                  Membership
                </Link>
              </li>
              <li>
                <Link to="/facility-reservation" className="hover:text-blue-400 transition-colors">
                  Facility Reservation
                </Link>
              </li>
              <li>
                <Link to="/events" className="hover:text-blue-400 transition-colors">
                  Events
                </Link>
              </li>
              <li>
                <Link to="/board-minutes" className="hover:text-blue-400 transition-colors">
                  Board Minutes
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h3 className="text-lg font-semibold mb-4">About LFST</h3>
            <p className="text-gray-300 leading-relaxed">
              Lockridge Forest Swim & Tennis Club is a private, members-only club
              located in Peachtree Corners, Georgia. We offer year-round recreation
              with our pool, tennis courts, and social events.
            </p>
            <div className="mt-4">
              <a
                href="https://www.facebook.com/groups/lockridgeforest"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-400 hover:text-blue-300 transition-colors"
              >
                <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                Join our Facebook Group
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-400">
          <p>&copy; {currentYear} Lockridge Forest Swim & Tennis Club. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
